'use client'

import { useEffect, useSyncExternalStore } from 'react'
import { Field, Select } from './ui'
import { applyThemePreference, getThemePreference, setThemePreference, subscribeThemePreference, type ThemePreference as Preference } from '@/lib/theme'

const serverPreference = (): Preference => 'system'

export function ThemeSync() {
  useEffect(() => {
    applyThemePreference(getThemePreference())
    return subscribeThemePreference(() => {})
  }, [])
  return null
}

export default function ThemePreference() {
  const value = useSyncExternalStore(subscribeThemePreference, getThemePreference, serverPreference)
  return <Field label="Theme" hint="System follows your device’s appearance.">
    <Select value={value} onChange={event => setThemePreference(event.target.value as Preference)}
      options={[{ value: 'system', label: 'System' }, { value: 'light', label: 'Light' }, { value: 'dark', label: 'Dark' }]} />
  </Field>
}
